import './bridgesrestaurant/style';
import FormStructure from './bridgesrestaurant/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js